module.exports = __webpack_public_path__ + "VIPV26.png?e5af752a687f21a42a6ec31ef2174780";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV26.png
// module id = 121
// module chunks = 0